<div
  class="ui raised segments chat-container chat-popup animation"
  *ngIf="isShowChatbot"
>
  <ng-container [ngSwitch]="isChatEnd">
    <ng-container *ngSwitchCase="false">
      <div
        class="ui secondary inverted segment chat-header"
        (click)="showEmoji(false)"
      >
        <ng-container [ngSwitch]="isChatExists">
          <!-- Normal header -->
          <ng-container *ngSwitchCase="false">
            <h2 class="ui header" @fadeIn>
              Hi there, Ask us Anything
              <em data-emoji=":wave:"></em>
              <a
                href="javascript:0"
                class="ui right floated text-white mobile-close hidden"
                (click)="toggle()"
                ><i class="times icon"></i
              ></a>
            </h2>
          </ng-container>
          <ng-container *ngSwitchCase="true">
            <!-- Main Heder with dropdown -->
            <h2 class="ui header" @fadeIn>
              Hi there, Ask us Anything
              <em data-emoji=":wave:"></em>
              <a
                href="javascript:0"
                class="ui right floated text-white mobile-close hidden"
                (click)="toggle()"
                ><i class="times icon"></i
              ></a>

              <div class="ui right floated dropdown" fuiDropdown>
                <i class="ellipsis horizontal icon"></i>
                <div class="menu" fuiDropdownMenu>
                  <a class="item"
                    ><i class="envelope outline icon"></i>Send Transcription</a
                  >
                  <a class="item" (click)="endChat()"
                    ><i class="power off icon"></i>End Chat</a
                  >
                </div>
              </div>
            </h2>
            <div class="ui mini images" @fadeIn>
              <img
                class="ui avatar image"
                *ngFor="let admin of admins"
                [src]="admin?.photoURL"
              />
            </div>
          </ng-container>
        </ng-container>
      </div>

      <ng-container [ngSwitch]="isChatExists">
        <!-- Chat body -->
        <ng-container *ngSwitchCase="true">
          <div class="ui segment bg-color chat-view-container">
            <div class="chat-body">
              <div class="ui comments" @fadeIn>
                <cdk-virtual-scroll-viewport
                  (click)="showEmoji(false)"
                  itemSize="chatBot?.messages?.length"
                >
                  <div
                    class="ui inverted comment"
                    *cdkVirtualFor="let message of chatBot?.messages"
                    [ngClass]="
                      chatBot?.userId === message?.senderId
                        ? 'right-floated-comment'
                        : 'left-floated-comment'
                    "
                  >
                    <a class="avatar">
                      <img src="{{ message?.photoURL }}" />
                    </a>
                    <div class="content">
                      <div class="ui label">
                        <div class="text">
                          <p>{{ message.message }}</p>
                        </div>
                        <div class="metadata">
                          <span class="date mini">{{
                            message.createdAt | date: 'shortTime'
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </cdk-virtual-scroll-viewport>
                <emoji-mart
                  (mouseleave)="showEmoji(false)"
                  (emojiClick)="selctedEmoji($event)"
                  *ngIf="isShowEmoji"
                  [style]="{
                    width: '100%',
                    position: 'absolute',
                    bottom: '0px',
                    right: '0px',
                    left: '0px',
                    margin: '0 auto'
                  }"
                  @fadeIn
                ></emoji-mart>
                <div class="ui basic bg-color segment msg-field">
                  <form
                    class="ui reply form input-form bg-white"
                    [formGroup]="chatForm"
                  >
                    <div class="ui fluid transparent input">
                      <input
                        type="text"
                        placeholder="Type a message"
                        formControlName="message"
                      />
                      <button
                        type="button"
                        (click)="showEmoji(true)"
                        class="ui icon button"
                      >
                        <i
                          class="icon"
                          [ngClass]="{
                            'meh outline': !isShowEmoji,
                            grin: isShowEmoji
                          }"
                        ></i>
                      </button>
                      <button
                        type="submit"
                        class="ui icon button"
                        (click)="sendMessage()"
                      >
                        <i class="paper plane outline icon"></i>
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
        <!-- Start conversion -->
        <ng-container *ngSwitchCase="false">
          <div class="ui segment bg-color chat-view-container">
            <div class="ui comments chat-body"></div>
          </div>
          <div class="ui raised card pos-absolute start-conversation-card">
            <div class="content fluid">
              <div class="ui header">Start conversation</div>
              <div class="description">
                <div class="ui tiny images">
                  <img
                    class="ui avatar image"
                    *ngFor="let admin of admins"
                    [src]="admin?.photoURL"
                  />
                  <!-- <span class="avatar-count">
                    2
                  </span> -->
                </div>
              </div>
              <div class="meta">
                The team typically replies within a minutes
              </div>
            </div>
            <div class="content">
              <button
                class="ui circular raised button primary basic"
                (click)="startConversation()"
              >
                <i class="paper plane outline icon"></i>
                New conversation
              </button>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <!-- Closer  -->
    <ng-container *ngSwitchCase="true">
      <ng-container [ngSwitch]="feedBackResponse">
        <ng-container *ngSwitchCase="chatFeedBackScreen.CHAT_FEEDBACK">
          <ng-container *ngTemplateOutlet="feedbackScreen"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="chatFeedBackScreen.GOOD_FEEDBACK">
          <ng-container *ngTemplateOutlet="goodScreen"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="chatFeedBackScreen.BAD_FEEDBACK">
          <ng-container *ngTemplateOutlet="badScreen"></ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>
</div>

<!-- Chat Icon Floated starts -->
<div
  class="ui massive circular primary icon button right floated animation"
  (click)="toggle()"
  [ngClass]="{ chatactive: isShowChatbot }"
  @fadeIn
>
  <i class="comment">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 95.49 105.371"
    >
      <g
        id="Group_9909"
        data-name="Group 9909"
        transform="translate(13515.12 2005.967)"
      >
        <g
          id="Group_9908"
          data-name="Group 9908"
          transform="translate(-13515.423 -2006.098)"
        >
          <g id="Group_9907" data-name="Group 9907" transform="translate(0 0)">
            <g id="Group_9906" data-name="Group 9906">
              <g id="Group_9905" data-name="Group 9905">
                <g id="Group_9904" data-name="Group 9904">
                  <g id="Group_9903" data-name="Group 9903">
                    <g id="Group_9902" data-name="Group 9902">
                      <rect
                        id="Rectangle_17664"
                        data-name="Rectangle 17664"
                        width="90"
                        height="91"
                        rx="8"
                        transform="translate(0.302 0.13)"
                        fill="#fff"
                      />
                      <path
                        id="Path_10672"
                        data-name="Path 10672"
                        d="M2.564,0h46.32a2.564,2.564,0,0,1,2.564,2.564L46.428,21.346c0,1.416-8.975,21.5-10.391,21.5L2.564,44.5A2.564,2.564,0,0,1,0,41.931V2.564A2.564,2.564,0,0,1,2.564,0Z"
                        transform="matrix(0.616, -0.788, 0.788, 0.616, 29.055, 78.107)"
                        fill="#fff"
                      />
                      <circle
                        id="Ellipse_1283"
                        data-name="Ellipse 1283"
                        cx="4"
                        cy="4"
                        r="4"
                        transform="translate(25.302 28.13)"
                        fill="#7b4fff"
                      />
                      <circle
                        id="Ellipse_1284"
                        data-name="Ellipse 1284"
                        cx="4"
                        cy="4"
                        r="4"
                        transform="translate(57.302 28.13)"
                        fill="#7b4fff"
                      />
                      <g
                        id="Subtraction_1"
                        data-name="Subtraction 1"
                        transform="translate(31.341 58.538)"
                        fill="#7b4fff"
                        stroke-linecap="square"
                      >
                        <path
                          d="M 14.63066005706787 7.23315954208374 C 11.83942031860352 7.23315954208374 9.181480407714844 6.432809352874756 6.944210052490234 4.918619632720947 C 5.931526660919189 4.233236312866211 5.035730361938477 3.420222759246826 4.279014110565186 2.499999523162842 L 24.98217964172363 2.499999523162842 C 24.22541809082031 3.42024827003479 23.32963180541992 4.233226776123047 22.31691932678223 4.918619632720947 C 20.07961082458496 6.432799339294434 17.42174911499023 7.23315954208374 14.63066005706787 7.23315954208374 Z"
                          stroke="none"
                        />
                        <path
                          d="M 14.63066005706787 9.733159065246582 C 11.33798980712891 9.733159065246582 8.195509910583496 8.784249305725098 5.542970180511475 6.989019393920898 C 4.266109943389893 6.124839305877686 3.1423499584198 5.088419437408447 2.202929973602295 3.908549547195435 C 1.252600073814392 2.714989423751831 0.511430025100708 1.399969577789307 2.990722691720293e-08 -4.673767080021207e-07 L 29.26128005981445 -4.673767080021207e-07 C 28.74953079223633 1.400779485702515 28.00815010070801 2.715579509735107 27.05825996398926 3.908549547195435 C 26.11881065368652 5.088419437408447 24.99502944946289 6.124839305877686 23.71814918518066 6.989019393920898 C 21.06558036804199 8.784249305725098 17.92317008972168 9.733159065246582 14.63066005706787 9.733159065246582 Z"
                          stroke="none"
                          fill="#7b4fff"
                        />
                      </g>
                      <g
                        id="Subtraction_2"
                        data-name="Subtraction 2"
                        transform="translate(34.121 54.366)"
                        fill="#fff"
                      >
                        <path
                          d="M 11.84971904754639 7.23315954208374 C 9.776299476623535 7.23315954208374 7.785459041595459 6.485369682312012 6.0924391746521 5.070629596710205 C 5.251938819885254 4.368289470672607 4.509318828582764 3.521449565887451 3.885209083557129 2.553659439086914 C 3.87371301651001 2.535832405090332 3.862212896347046 2.51789379119873 3.850806951522827 2.499999523162842 L 19.84850311279297 2.499999523162842 C 19.83709716796875 2.51789379119873 19.82561492919922 2.535802125930786 19.81411933898926 2.553629636764526 C 19.19000816345215 3.521419525146484 18.44737815856934 4.368249416351318 17.6068286895752 5.070629596710205 C 15.91379928588867 6.485369682312012 13.92301940917969 7.23315954208374 11.84971904754639 7.23315954208374 Z"
                          stroke="none"
                        />
                        <path
                          d="M 11.84971904754639 9.733159065246582 C 9.18290901184082 9.733159065246582 6.637739181518555 8.784249305725098 4.489378929138184 6.989019393920898 C 3.455219030380249 6.124839305877686 2.545068979263306 5.088419437408447 1.784198999404907 3.908549547195435 C 1.014508962631226 2.714989423751831 0.4142190217971802 1.399969577789307 -9.796142421691911e-07 -4.673767080021207e-07 L 23.69939994812012 -4.673767080021207e-07 C 23.28491973876953 1.400779485702515 22.6844596862793 2.715579509735107 21.91511917114258 3.908549547195435 C 21.15423965454102 5.088419437408447 20.24405860900879 6.124839305877686 19.20988845825195 6.989019393920898 C 17.06150817871094 8.784249305725098 14.51639938354492 9.733159065246582 11.84971904754639 9.733159065246582 Z"
                          stroke="none"
                          fill="#fff"
                        />
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  </i>
  <i class="times">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      version="1.1"
      id="Capa_1"
      x="0px"
      y="0px"
      viewBox="0 0 512.001 512.001"
      style="enable-background: new 0 0 512.001 512.001"
      xml:space="preserve"
      width="20px"
      height="20px"
      class=""
    >
      <g>
        <g>
          <g>
            <path
              d="M284.286,256.002L506.143,34.144c7.811-7.811,7.811-20.475,0-28.285c-7.811-7.81-20.475-7.811-28.285,0L256,227.717    L34.143,5.859c-7.811-7.811-20.475-7.811-28.285,0c-7.81,7.811-7.811,20.475,0,28.285l221.857,221.857L5.858,477.859    c-7.811,7.811-7.811,20.475,0,28.285c3.905,3.905,9.024,5.857,14.143,5.857c5.119,0,10.237-1.952,14.143-5.857L256,284.287    l221.857,221.857c3.905,3.905,9.024,5.857,14.143,5.857s10.237-1.952,14.143-5.857c7.811-7.811,7.811-20.475,0-28.285    L284.286,256.002z"
              data-original="#000000"
              class="active-path"
              data-old_color="#000000"
              fill="#FFFFFF"
            />
          </g>
        </g>
      </g>
    </svg>
  </i>
</div>
<!-- Chat Icon Floated ends -->

<ng-template #feedbackScreen>
  <div class="chat-closure animation">
    <div class="ui centered middle aligned grid" @fadeIn>
      <div class="sixteen wide column">
        <div class="ui center aligned placeholder segment">
          <a
            href="javascript:0"
            class="ui right floated mobile-close hidden"
            (click)="toggle()"
            ><i class="times icon"></i
          ></a>
          <div class="ui icon header">This chat session has ended</div>
          <div>
            <p>
              Thank you for chatting with us, if you can take a minute and rate
              this chat:
            </p>
          </div>
          <div class="ui basic segment">
            <div class="ui grid">
              <div class="eight wide column">
                <div class="ui clearing segment">
                  <div
                    class="ui right floated teal huge icon button"
                    (click)="
                      takeFeedBack(chatFeedBackScreen.GOOD_FEEDBACK, good)
                    "
                  >
                    <i class="thumbs up outline icon"></i>
                  </div>
                </div>
                <div class="ui clearing segment">
                  <a class="ui right floated teal text">Good</a>
                </div>
              </div>
              <div class="eight wide column">
                <div class="ui clearing segment">
                  <div
                    class="ui left floated red huge icon button"
                    (click)="takeFeedBack(chatFeedBackScreen.BAD_FEEDBACK, bad)"
                  >
                    <i class="thumbs down outline icon"></i>
                  </div>
                </div>
                <div class="ui left aligned clearing segment">
                  <a class="ui left floated red text">Bad</a>
                </div>
              </div>
            </div>
          </div>
          <div class="ui center aligned compact segment">
            <a class="link-text">Need a Transcript?</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #goodScreen>
  <div class="thankyou-screen animation">
    <div class="ui centered middle aligned grid">
      <div class="sixteen wide column" @fadeIn>
        <a
          href="javascript:0"
          class="ui right floated mobile-close hidden"
          (click)="toggle()"
          ><i class="times icon"></i
        ></a>
        <h2 class="ui center aligned icon header">
          <i class="grin alternate outline icon"></i>
          Thank You
        </h2>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #badScreen>
  <div class="thankyou-screen warning animation">
    <div class="ui centered middle aligned grid">
      <div class="sixteen wide column" @fadeIn>
        <div class="ui center aligned placeholder segment">
          <a
            href="javascript:0"
            class="ui right floated mobile-close hidden"
            (click)="toggle()"
            ><i class="times icon"></i
          ></a>
          <h2 class="ui center aligned icon header">
            <i class="frown outline icon"></i>
            Thank You
          </h2>
        </div>
      </div>
    </div>
  </div>
</ng-template>
